import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
};
const isDark = () => document.documentElement.classList.contains('dark');

/** Follows the app theme (the `dark` class on <html>), for widgets that need it as a value. */
export function useIsDark(): boolean {
  return useSyncExternalStore(subscribe, isDark, () => false);
}
